import PropTypes from 'prop-types';
import qs from 'qs';
import React, { useContext, useEffect, useState } from 'react';
import { useSearchMode } from './searchModeContext';
import { useSearchType } from './searchTypeContext';

export const ViewTypeContext = React.createContext();
export const useViewTypeContext = () => {
    return useContext(ViewTypeContext);
};

const defaultViewTypes = {
    articles: 'card',
    events: 'card',
    properties: 'card',
};

export const ViewTypeProvider = ({ children }) => {
    const { isPublicationsSearch } = useSearchMode();
    const [searchType] = useSearchType();
    const [viewType, setViewType] = useState();

    useEffect(() => {
        const defaultView = isPublicationsSearch ? 'card' : defaultViewTypes[searchType?.index] || 'list';
        const { view: viewFromUrl } = qs.parse(window.location.search.slice(1));
        setViewType(viewFromUrl || defaultView);
    }, [isPublicationsSearch, searchType, setViewType]);

    return <ViewTypeContext.Provider value={[viewType, setViewType]}>{children}</ViewTypeContext.Provider>;
};

ViewTypeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
